import loadable from '@loadable/component';

export const LazyAdmin = loadable(() => import(/* webpackChunkName: "content/admin" */ './Admin'));
